import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Tag } from 'lucide-react';

const formatDate = (iso) => {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString('en-AU', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return '';
  }
};

export const PostCard = ({ post }) => (
  <Link
    to={`/blog/${post.slug}`}
    data-testid={`blog-card-${post.slug}`}
    className="group flex flex-col rounded-3xl border border-slate-200 bg-white overflow-hidden hover:border-slate-300 hover:shadow-xl hover:shadow-slate-900/5 transition-all"
  >
    {post.cover_image_url ? (
      <div className="aspect-[16/9] overflow-hidden bg-slate-100">
        <img
          src={post.cover_image_url}
          alt={post.title}
          className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
          loading="lazy"
        />
      </div>
    ) : (
      <div className="aspect-[16/9] bg-gradient-to-br from-violet-100 via-indigo-50 to-white" />
    )}
    <div className="p-6 flex-1 flex flex-col">
      <div className="flex flex-wrap items-center gap-2 text-[11px] uppercase tracking-[0.14em] font-medium text-slate-500">
        {post.tags?.slice(0, 2).map((t) => (
          <span
            key={t}
            className="inline-flex items-center gap-1 rounded-full bg-violet-50 text-violet-700 px-2.5 py-1"
          >
            <Tag size={10} /> {t}
          </span>
        ))}
        <span>{formatDate(post.published_at || post.created_at)}</span>
      </div>
      <h3 className="mt-3 font-display text-[22px] leading-tight font-semibold text-slate-900 tracking-tight group-hover:text-violet-700 transition-colors">
        {post.title}
      </h3>
      {post.excerpt && (
        <p className="mt-2.5 text-[14.5px] leading-relaxed text-slate-600 line-clamp-3">
          {post.excerpt}
        </p>
      )}
      <div className="mt-4 inline-flex items-center gap-1.5 text-[13.5px] font-medium text-violet-700">
        Read post <ArrowRight size={14} className="group-hover:translate-x-0.5 transition-transform" />
      </div>
    </div>
  </Link>
);
